const getAverageAttendeesPerEvent = (allAttendees, totalActivities) => {
  let averageAttendeesPerEvent = (Math.round(allAttendees.length / totalActivities * 10) / 10)
  if (isNaN(averageAttendeesPerEvent)) {
    averageAttendeesPerEvent = 0
  }
  return averageAttendeesPerEvent
}

export default getAverageAttendeesPerEvent
